import React from 'react';

import { SessionProvider } from '../../context/session-context';

type Props = {
  children: React.ReactElement;
};

const AuthProvider = ({ children }: Props) => {
  return <SessionProvider>{children}</SessionProvider>;
};

export default AuthProvider;
